export default __webpack_public_path__ + "848415c429452bd53cc2af949fdda8b8.png";